if (!customElements.get('product-tile')) {
  class ProductTile extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      const swiperEl = this.querySelector('swiper-container[data-product-images]');
      if (!swiperEl) return;

      const paginationEl = this.querySelector('[data-pagination]');
      if (!paginationEl) return;

      const bullets = Array.from(paginationEl.querySelectorAll('.swatch-bullet'));
      if (!bullets.length) return;

      const setup = (swiper) => {
        bullets.forEach((btn, index) => {
          btn.addEventListener('click', () => {
            swiper.slideTo(index);
          });
        });

        const updateActive = () => {
          bullets.forEach((b) => b.classList.remove('is-active'));
          const active = bullets[swiper.activeIndex];
          if (active) active.classList.add('is-active');
        };

        swiper.on('slideChange', updateActive);
        updateActive();
      };

      const waitForSwiper = () => {
        if (swiperEl.swiper) {
          setup(swiperEl.swiper);
        } else {
          requestAnimationFrame(waitForSwiper);
        }
      };

      waitForSwiper();
    }
  }

  customElements.define('product-tile', ProductTile);
}
